import _ from "lodash";
import { log } from "../Helper";
import { format } from "date-fns";
import { getAccessToken } from "../utils/okta-config";
import { API_ROOT } from "../constants/constants";
import { currencyPayload } from "./utility/constants";

export async function internalQuoteOrders(pageNumber, pageSize) {
  try {
    let url =
      `${process.env.REACT_APP_API_ENDPOINT}/manageQuoteOrder/internalQuoteOrder/` +
      pageNumber +
      `/` +
      pageSize;

    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        "Access-Control-Allow-Origin": API_ROOT,
      },
    };
    const response = await fetch(url, requestOptions);
    const result = await response.json();
    const tableData = result.content.map((quote) => {
      if (result) {
        quote.comar = quote.orderUnit + quote.orderNumber;
      }
      return quote;
    });
    return tableData;
  } catch (error) {}
}

export async function getAllSubmittedQuoetsByForwarders(pageNumber, pageSize) {
  try {
    let url =
      `${process.env.REACT_APP_API_ENDPOINT}/manageQuoteOrder/allSubmittedQuotes/` +
      pageNumber +
      `/` +
      pageSize;

    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        "Access-Control-Allow-Origin": API_ROOT,
      },
    };
    const response = await fetch(url, requestOptions);
    const result = await response.json();
    const tableData = result.content.map((quote) => {
      if (result) {
        quote.comar = quote.orderUnit + quote.orderNumber;
        quote.pickLocation = quote.fromCountry + "_" + quote.fromCity;
        quote.shipDestination =
          quote.shipToCountry + "-" + quote.shipToZip + " " + quote.shipToCity;
      }
      quote.forwarderSubmittedList.map((submittedQuote) => {
        submittedQuote.price = submittedQuote.price.toFixed(2);
      });

      return quote;
    });
    return tableData;
  } catch (error) {}
}

export async function chooseWinner(reqObj) {
  let url = `${process.env.REACT_APP_API_ENDPOINT}/manageQuoteOrder/approveWinner`;
  let priceWithCurrency = reqObj.price
  let currency = ""
  Object.keys(currencyPayload).forEach((key, index) => (
    priceWithCurrency.slice(-1) === currencyPayload[key]?
      currency = key : currency
  ))
  const request = {
    quoteId: reqObj.quoteId,
    submittedId: reqObj.submittedId,
    providerId: reqObj.providerId,
    providerName: reqObj.providerName,
    price: priceWithCurrency.substring(0,priceWithCurrency.length-1),
    currency: currency,
    isActive: reqObj.isActive,
    orderPathId: reqObj.orderPathId,
    zip: reqObj.shipToZip,
    zipCostId: reqObj.zipCostId
  };

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getAccessToken()}`,
      "Access-Control-Allow-Origin": API_ROOT,
    },

    body: JSON.stringify(request),
  };

  const response = await fetch(url, requestOptions);
  const result = await response.json();
  return result;
}

export async function setStartQuote(reqObj) {
  let url = `${process.env.REACT_APP_API_ENDPOINT}/manageQuoteOrder/startQuote`;

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getAccessToken()}`,
      "Access-Control-Allow-Origin": API_ROOT,
    },
    body: JSON.stringify(reqObj),
  };
  log("Starting quote : req - ", reqObj)
  const response = await fetch(url, requestOptions);
  const result = await response.json();
  log("start or update submitted quote response-- ", result);
  return result;
}

export async function quoteResultsDataInternal(pageNumber, pageSize) {
  try {
    let url =
      `${process.env.REACT_APP_API_ENDPOINT}/manageQuoteOrder/allQuoteResults/` +
      pageNumber +
      `/` +
      pageSize;

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getAccessToken()}`,
        "Access-Control-Allow-Origin": API_ROOT,
      },
    };

    const response = await fetch(url, requestOptions);
    log(response);
    const result = await response.json();
    //log("QUOTE RESULT INTERNAL",result);
    const tableData = result.content.map((quote) => {
      if (result) {
        if (!_.isEmpty(quote.expectedTimeframe)) {
          const formattedETF = new Date(quote.expectedTimeframe);
          const expectedTimeframe =
            format(formattedETF, "yyyy-MM-dd") +
            "(" +
            "+" +
            quote.pickupDays +
            ")";
          quote.expectedTimeframe = expectedTimeframe;
        } else {
          quote.expectedTimeframe = "";
        }
        quote.comar = quote.orderUnit + quote.orderNumber;
        quote.amount = quote.amount + currencyPayload[quote.currency];
      }
      return quote;
    });
    return tableData;
  } catch (error) {
    console.log(error);
  }
}

export async function deleteQuoteRequest(reqObj) {
  let url = `${process.env.REACT_APP_API_ENDPOINT}/manageQuoteOrder/deleteQuote`;

  const request = {
    orderPathId: reqObj.deleteQuotedMachineDTOList[0].orderPathId,
    orderYear: reqObj.deleteQuotedMachineDTOList[0].orderYear,
    submittedId: reqObj.deleteQuotedMachineDTOList[0].submittedId,
    orderUnit: reqObj.deleteQuotedMachineDTOList[0].orderUnit,
    orderNumber: reqObj.deleteQuotedMachineDTOList[0].orderNumber,
    quoteId: reqObj.deleteQuotedMachineDTOList[0].quoteId,
    comar: reqObj.deleteQuotedMachineDTOList[0].comar,
  };

  const requestOptions = {
    method: "DELETE",
    headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getAccessToken()}`,
        "Access-Control-Allow-Origin": API_ROOT,
      },
    body: JSON.stringify(request),
  };

  const response = await fetch(url, requestOptions);
  const result = await response.json();
  return result;
}

export async function deleteQuoteFromResultsPage(reqObj) {
  let url = `${process.env.REACT_APP_API_ENDPOINT}/manageQuoteOrder/deleteQuoteResult`;

  const request = {
    orderPathId: reqObj.deleteQuoteResultMachineDTOList[0].orderPathId,
    quoteId: reqObj.deleteQuoteResultMachineDTOList[0].quoteId,
  };

  const requestOptions = {
    method: "DELETE",
    headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getAccessToken()}`,
        "Access-Control-Allow-Origin": API_ROOT,
      },
    body: JSON.stringify(request),
  };

  const response = await fetch(url, requestOptions);
  const result = await response.json();
  return result;
}
